import React from 'react'
import Unit from './Unit'
import classNames from 'classnames';

const UnitHolder = ({ unit, status = false, campus, disabled }) => {
  return (
    <div className={classNames('unit-holder', { 'unit-holder--complete': status === 'COMP' }, { 'unit-holder--invalid': status === 'INVALID' })}>
      <Unit
        code={unit.unitCode}
        name={unit.unitShortTitle}
        creditPoints={`${unit.unitCreditPoints || 0} points`}
        campus={campus}
        core={false}
        attendanceMode={unit.unitAvailabilityAttendanceModeCode}
        virtual={unit.virtual}
        hasRequisite={unit.unitRequisiteFlag || false}
      />
    </div>
  )
}

export default UnitHolder